// extracted by mini-css-extract-plugin
module.exports = {"btn_group":"styles_btn_group__1-cIz","confirm_change_collected":"styles_confirm_change_collected__1F-PM","checked_state":"styles_checked_state__1C0tF"};